// WithMessagePinData.jsx
import { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';

import PinIconResource from '../../img/ic_pin_outline.svg';
import PinnedIconResource from '../../img/ic_pin.svg';

export const WithMessagePinData = ({
  messageId,
  meId,
  senderId,
  feedNameWithQuery,
  profileFeedUnixTimestamp,
  pinnedItemIds,
  isFetched,
  children,
  fetchFeeds,
  updateProfileFeedUnixTimestamp,
}) => {
  const isAuthor = useMemo(() => meId && meId === senderId, [meId, senderId]);
  // Update timestamp and re-fetch feeds if author and timestamp not exist.
  useEffect(() => {
    if (isAuthor && !profileFeedUnixTimestamp) {
      const unixTimestamp = getCurrentUnixTimestamp();
      updateProfileFeedUnixTimestamp({
        unixTimestamp,
      });
      fetchFeeds({
        type: feedNameWithQuery,
        unixTimestamp,
        shouldSkipLocalCache: true,
      });
    }
  }, [
    feedNameWithQuery,
    fetchFeeds,
    isAuthor,
    profileFeedUnixTimestamp,
    updateProfileFeedUnixTimestamp,
  ]);
  // Fetch feeds first page to generate pinned item ids
  useEffect(() => {
    if (!isFetched) {
      fetchFeeds({
        type: feedNameWithQuery,
        unixTimestamp: isAuthor ? profileFeedUnixTimestamp : undefined,
        shouldSkipLocalCache: true,
      });
    }
  }, [
    feedNameWithQuery,
    fetchFeeds,
    isAuthor,
    isFetched,
    profileFeedUnixTimestamp,
  ]);
  const isPinned = useMemo(() => {
    return pinnedItemIds.includes(messageId);
  }, [messageId, pinnedItemIds]);
  return children({
    isPinned,
    iconSource: isPinned ? PinnedIconResource : PinIconResource,
  });
};

WithMessagePinData.propTypes = {
  messageId: PropTypes.string,
  meId: PropTypes.string,
  senderId: PropTypes.string,
  feedNameWithQuery: PropTypes.string,
  profileFeedUnixTimestamp: PropTypes.number,
  pinnedItemIds: PropTypes.array,
  isFetched: PropTypes.bool,
  children: PropTypes.func,
  fetchFeeds: PropTypes.func,
  updateProfileFeedUnixTimestamp: PropTypes.func,
};

WithMessagePinData.defaultProps = {
  messageId: null,
  meId: null,
  senderId: null,
  feedNameWithQuery: null,
  profileFeedUnixTimestamp: null,
  pinnedItemIds: [],
  isFetched: false,
  children: () => null,
  fetchFeeds: () => null,
  updateProfileFeedUnixTimestamp: () => null,
};

export default WithMessagePinData;
